var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Event Dispatcher
 */
export class EventDispatcher {
    constructor() {
        this.eventListeners = new Map();
    }
    /**
     * Sets parent
     * @param parent parent
     */
    setParent(parent) {
        this.parent = parent;
    }
    /**
     * Gets parent
     */
    getParent() {
        return this.parent;
    }
    /**
     * Adds event listener
     * @param eventType event type
     * @param eventListener event listener
     */
    addEventListener(eventType, eventListener) {
        let listeners = this.eventListeners.get(eventType);
        if (!listeners) {
            listeners = [];
            this.eventListeners.set(eventType, listeners);
        }
        listeners.push(eventListener);
    }
    /**
     * Removes event listener
     * @param eventType event type
     * @param eventListener event listener
     */
    removeEventListener(eventType, eventListener) {
        let listeners = this.eventListeners.get(eventType);
        if (listeners) {
            let index = listeners.indexOf(eventListener);
            if (index >= 0) {
                listeners.splice(index, 1);
            }
        }
    }
    /**
     * Clears event listeners
     * @param eventType event type
     */
    clearEventListeners(eventType) {
        this.eventListeners.delete(eventType);
    }
    /**
     * Dispatches event listeners
     * @param event event
     */
    dispatchEventListeners(event) {
        return __awaiter(this, void 0, void 0, function* () {
            let listeners = this.eventListeners.get(event.constructor);
            let results = [];
            if (listeners) {
                for (let listener of listeners) {
                    results.push(yield listener.call(this, event));
                }
            }
            // calls parent
            if (this.parent) {
                let parentResults = yield this.parent.dispatchEventListeners(event);
                results = results.concat(parentResults);
            }
            // returns results
            return results;
        });
    }
}
//# sourceMappingURL=EventDispatcher.js.map